var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Echarts"},[_c('div',{staticStyle:{"width":"100%","height":"440px","background-color":"#FFFFFF","box-sizing":"border-box","padding":"20px 20px 0","border-radius":"10px"},attrs:{"id":_vm.chart.idName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }